import React, {useEffect} from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {DealerToggle} from "./DealerToggle";
import {LocationInline} from "./LocationInline";
import {VehicleCard} from "./VehicleCard";
import {useListingsStore} from "../../stores/listingsStore";
import {useSavedDealershipsStore} from "../../stores/savedDealershipsStore";
import {useShallow} from "zustand/react/shallow";
import {ListingsMap} from "./ListingsMap";
import CustomInfiniteScroll from '../../components/CustomInfiniteScroll';


export function MainContent() {
    // Load the user's saved dealerships once so the save toggles reflect state.
    const fetchSavedDealerships = useSavedDealershipsStore((state) => state.fetchSaved)
    useEffect(() => { fetchSavedDealerships() }, [fetchSavedDealerships])

    const {
        listings,
        loading,
        setPagination,
        count,
        viewMode,
        setViewMode,
        start,
        rows,
    } = useListingsStore(
        useShallow((state) => ({
            listings: state.listings,
            loading: state.loading,
            setPagination: state.setPagination,
            count: state.count,
            start: state.start,
            rows: state.rows,
            viewMode: state.viewMode,
            setViewMode: state.setViewMode,
        }))
    )

    const isMapView = viewMode === 'map'
    // `start` is the offset of the last-loaded page, so `start + rows` is how many
    // we've actually loaded — there's more only while that's below the total.
    // (Was `start * rows`, which treated the offset as a page index and stopped
    // ~4 pages in.)
    const hasMore = Boolean(start + rows < count)

    return (
        <main className="main">
            <div className="results-header">
                <LocationInline/>
                <DealerToggle/>
                <div className="results-header-right">
                    <span className="results-count">
                        {count} result{count === 1 ? '' : 's'}
                        {loading && <CircularProgress size={13} style={{marginLeft: 8, verticalAlign: 'middle'}}/>}
                    </span>
                    <div className="view-toggle">
                        <button className={`view-btn ${viewMode === "grid" ? "active" : ""}`} title="Grid view"
                                onClick={() => setViewMode("grid")}>
                            <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                <path
                                    d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"/>
                            </svg>
                        </button>
                        <button
                            className={`view-btn ${viewMode === "map" ? "active" : ""}`}
                            title="Map view"
                            onClick={() => setViewMode("map")}
                        >
                            <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd"
                                      d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103zM10 1.91l-4-.8v12.98l4 .8V1.91zm1 12.98 4-.8V1.11l-4 .8v12.98zm-6-.8V1.11l-4 .8v12.98l4-.8z"/>
                            </svg>
                        </button>
                        {/*<button className={`view-btn ${viewMode === "list" ? "active" : ""}`} title="List view"*/}
                        {/*        onClick={() => setViewMode("list")}>*/}
                        {/*    <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">*/}
                        {/*        <path fillRule="evenodd"*/}
                        {/*              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>*/}
                        {/*    </svg>*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>

            {
                !isMapView &&
                <div className="listings-scroll">
                  <div className="listings-scroll__inner">
                    <CustomInfiniteScroll
                        useWindow={false}
                        pageStart={0}
                        initialLoad={false}
                        loadMore={() => {
                            if (!loading && hasMore) {
                                const newStart = start + rows
                                setPagination({start: newStart})
                            }
                        }}
                        hasMore={hasMore}
                        className={''}
                    >
                        <div
                            className="vehicle-grid"
                            style={{
                                opacity: loading ? 0.5 : 1,
                                transition: 'opacity .15s',
                            }}
                        >
                            {listings.map(v => <VehicleCard key={v.vin} vehicle={v}/>)}
                        </div>
                        {
                            loading && listings.length === 0 &&
                            <div style={{display: 'flex', justifyContent: 'center', padding: '60px 0'}}>
                                <CircularProgress/>
                            </div>
                        }
                        {
                            !loading && listings.length === 0 &&
                            <div style={{textAlign: 'center', color: '#8a8f9e', padding: '60px 0'}}>
                                No vehicles found.
                            </div>
                        }
                    </CustomInfiniteScroll>
                    {/*<ListingsPagination/>*/}
                  </div>
                </div>
            }
            {
                <div style={{ display: isMapView ? 'block': 'none'}}>
                    <ListingsMap
                        initialCenter={{ lat: 34.070389, lng: -118.362314 }}
                    />
                </div>
            }

        </main>
    );
}